import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {UpdateService} from './report.service';
import {
  DASHBOARD_ROUTE,
  GROUP_REPORT_ROUTE,
  MODAL_RESULT_OK,
  PERSONAL_REPORT_ROOT_ROUTE,
  PERSONAL_REPORT_ROUTE
} from './report-datepicker.constants';
import {
  GroupReportStorageContext,
  PersonalReportPresentationContext
} from './report-datepicker.types';
import {ReportDatepickerUiGateway} from './report-datepicker-ui.gateway';

@Injectable()
export class ReportDatepickerReportPresenter {
  constructor(
    private router: Router,
    private updateService: UpdateService,
    private ui: ReportDatepickerUiGateway
  ) {
  }

  showPersonalReport(context: PersonalReportPresentationContext): void {
    this.ui.storePersonalReport(context);
    this.ui.close();
    this.openReport(context.department
      ? PERSONAL_REPORT_ROUTE + context.userId : PERSONAL_REPORT_ROOT_ROUTE);
  }

  showGroupReport(context: GroupReportStorageContext, afterClose: () => void): void {
    this.ui.storeGroupReport(context);
    this.ui.close();
    afterClose();
    this.openReport(GROUP_REPORT_ROUTE);
  }

  private openReport(route: string): void {
    const sameReport = this.router.url === route;
    this.router.navigate([route]).then(navigated => {
      if (navigated || sameReport) {
        this.updateService.notifyUpdate();
      }
    });
  }

  showVector(vector: Object): void {
    this.ui.storeVector(vector);
    this.ui.close(MODAL_RESULT_OK);
  }

  showDayOffSuccess(): void {
    this.ui.close(MODAL_RESULT_OK);
  }

  navigateToDashboard(): void {
    this.router.navigate([DASHBOARD_ROUTE]);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-report.presenter.ts